// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"759":"b2c70cd72d9fc313","5529":"8af80a5efd948a2c","5959":"bd203881556bf549"}[chunkId] + ".js";
};